import { IUserAnalyticsPreset } from '@/pages/Users/users.types.ts'

const lpLiftPresets: IUserAnalyticsPreset[] = [
  {
    id: 'speed-chart',
    title: 'График скорости',
    isLocked: true,
    parameters: [
      {
        sourceId: 'carSpeed',
        color: '#2F54EB',
      },
      {
        sourceId: 'MDReadySgl',
        color: '#33a02c',
      },
      {
        sourceId: 'FCHSCmd',
        color: '#e31a1c',
      },
      {
        sourceId: 'FCSELTCmd',
        color: '#ff7f00',
      },
      {
        sourceId: 'FCDECCmd',
        color: '#6a3d9a',
      },
      {
        sourceId: 'LKMCCmd',
        color: '#b15928',
      },
      {
        sourceId: 'FCLSCmd',
        color: '#C41D7F',
      },
      {
        sourceId: 'ONKMCSgl',
        color: '#D4B106',
      },
    ],
  },
]

const lkdsPresets: IUserAnalyticsPreset[] = [
  {
    id: 'lkds-status-chart',
    title: 'График состояния',
    isLocked: true,
    parameters: [
      {
        sourceId: 'cabinMoving',
        color: '#2F54EB',
      },
      {
        sourceId: 'doorsState',
        color: '#33a02c',
      },
      {
        sourceId: 'doorControlRelay',
        color: '#e31a1c',
      },
      {
        sourceId: 'doorRelayForOpening',
        color: '#ff7f00',
      },
      {
        sourceId: 'doorRelayForClosing',
        color: '#6a3d9a',
      },
      {
        sourceId: 'drivingRelay',
        color: '#b15928',
      },
      {
        sourceId: 'movingRelayBlock',
        color: '#C41D7F',
      },
      {
        sourceId: 'safetyChainEnd',
        color: '#D4B106',
      },
      {
        sourceId: 'cabinLoadPercent',
        color: '#08979C',
      },
    ],
  },
]

const getPresets = (protocolId?: string): IUserAnalyticsPreset[] => {
  return protocolId === 'lkds' ? lkdsPresets : lpLiftPresets
}

const analyticsConstants = { getPresets }
export default analyticsConstants
